import React from 'react';
import { Header } from '../components/landing/Header';
import { Hero } from '../components/landing/Hero';
import { CreativeCarousel } from '../components/landing/CreativeCarousel';
import { PromoCampaign } from '../components/landing/PromoCampaign';
import { ProblemSolution } from '../components/landing/ProblemSolution';
import { HowItWorks } from '../components/landing/HowItWorks';
import { Testimonials } from '../components/landing/Testimonials';
import { ExpertValidation } from '../components/landing/ExpertValidation';
import { OfferSection } from '../components/landing/OfferSection';
import { Guarantee } from '../components/landing/Guarantee';
import { FAQ } from '../components/landing/FAQ';
import { FinalCTA } from '../components/landing/FinalCTA';
import { Footer } from '../components/landing/Footer';
import { MobilePromoButton } from '../components/landing/MobilePromoButton';
export function FinancialPackLanding() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-[#d4a574] selection:text-[#1e3a5f]" data-id="element-584">
      <Header data-id="element-585" />
      <main data-id="element-586">
        <Hero data-id="element-587" />
        <CreativeCarousel data-id="element-588" />
        <PromoCampaign data-id="element-589" />
        <HowItWorks data-id="element-590" />
        <Testimonials data-id="element-591" />
        <ExpertValidation data-id="element-592" />
        <OfferSection data-id="element-593" />
        <Guarantee data-id="element-594" />
        <FAQ data-id="element-595" />
        <FinalCTA data-id="element-596" />
      </main>
      <Footer data-id="element-597" />
      <MobilePromoButton data-id="element-598" />
    </div>;
}